export const AMPLITUDE = {
    API_KEY: '0b740449af153d0e4f224873d0144266',
};

export const NEW_RELIC = {
    APPLICATION_ID: '601672027',
    API_KEY: 'NRJS-8715e458ce0406aa41d',
};
